(function () {
  if (window.AdegaShippingCalculatorAssetLoaded) {
    if (typeof window.initAdegaShippingCalculators === "function") {
      window.initAdegaShippingCalculators(document);
    }

    return;
  }

  window.AdegaShippingCalculatorAssetLoaded = true;

  const BRAZIL = "Brazil";
  const NO_DELIVERY_MESSAGE = "No momento, ainda nao realizamos entregas para esta regiao. Estamos ampliando nossa cobertura e esperamos atender sua localidade em breve.";
  const SHIPPING_CONTEXT_STORAGE_KEY = "adega:last-deliverable-shipping-address";
  const STATE_NAMES = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapa",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceara",
    DF: "Distrito Federal",
    ES: "Espirito Santo",
    GO: "Goias",
    MA: "Maranhao",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Para",
    PB: "Paraiba",
    PR: "Parana",
    PE: "Pernambuco",
    PI: "Piaui",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondonia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "Sao Paulo",
    SE: "Sergipe",
    TO: "Tocantins"
  };

  function initShippingCalculators(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".js-shipping-calculator").forEach(function (calculator) {
      if (calculator.dataset.initialized === "true") {
        return;
      }

      calculator.dataset.initialized = "true";

      const cepInput = calculator.querySelector(".js-shipping-calculator-cep");
      const button = calculator.querySelector(".js-shipping-calculator-button");
      const feedback = calculator.querySelector(".js-shipping-calculator-feedback");
      const results = calculator.querySelector(".js-shipping-calculator-results");
      const serviceableZipRules = parseServiceableZipRules(calculator.dataset.serviceableZipRanges);
      let activeRequestId = 0;
      let shippingRatesRequested = false;

      if (!cepInput || !button || !feedback || !results) {
        return;
      }

      button.addEventListener("click", function (event) {
        event.preventDefault();
        calculateShipping();
      });

      calculator.addEventListener("shipping-calculator:reset", resetCalculator);
      cepInput.addEventListener("input", maskCep);
      cepInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          calculateShipping();
        }
      });

      calculator.AdegaShippingCalculator = {
        reset: resetCalculator
      };

      async function calculateShipping() {
        const requestId = ++activeRequestId;
        const cep = onlyDigits(cepInput.value);

        clearOutput();

        if (cep.length !== 8) {
          setFeedback("Digite um CEP valido com 8 numeros.", "error");
          return;
        }

        if (serviceableZipRules.length && !isServiceableZip(cep, serviceableZipRules)) {
          setFeedback(NO_DELIVERY_MESSAGE, "info");
          return;
        }

        setLoading(true);
        shippingRatesRequested = false;
        let cart = null;

        try {
          cart = await getCart();

          if (requestId !== activeRequestId) {
            return;
          }

          if (!cart.item_count) {
            setFeedback("Adicione um produto ao carrinho para calcular o frete.", "info");
            return;
          }

          const address = await getAddressFromCep(cep);

          if (requestId !== activeRequestId) {
            return;
          }

          shippingRatesRequested = true;
          const rates = await getShippingRates(cep, address.province);

          if (requestId !== activeRequestId) {
            return;
          }

          if (!rates.length) {
            if (serviceableZipRules.length) {
              await restoreCartItems(cart);
            } else {
              await restoreShippingAddressContext(cart);
            }

            if (requestId !== activeRequestId) {
              return;
            }

            setFeedback(NO_DELIVERY_MESSAGE, "info");
            return;
          }

          await restoreCartItems(cart);

          if (requestId !== activeRequestId) {
            return;
          }

          rememberShippingAddress(cep, address.province);
          renderRates(rates);
        } catch (error) {
          if (requestId !== activeRequestId) {
            return;
          }

          console.error("Erro ao calcular frete.", error);
          setFeedback(error.message || "Nao foi possivel calcular o frete agora. Tente novamente.", "error");

          if (shippingRatesRequested) {
            if (serviceableZipRules.length) {
              await restoreCartItems(cart);
            } else {
              await restoreShippingAddressContext(cart);
            }
          }
        } finally {
          if (requestId === activeRequestId) {
            setLoading(false);
          }
        }
      }

      async function getCart() {
        const response = await fetch(getShopifyRoot() + "cart.js", {
          headers: {
            Accept: "application/json"
          }
        });

        if (!response.ok) {
          throw new Error("Falha ao carregar o carrinho atual.");
        }

        return response.json();
      }

      async function getAddressFromCep(cep) {
        const response = await fetch("https://viacep.com.br/ws/" + cep + "/json/");

        if (!response.ok) {
          throw new Error("Falha ao consultar o CEP.");
        }

        const address = await response.json();

        if (address.erro || !address.uf) {
          throw new Error("CEP invalido.");
        }

        return {
          province: STATE_NAMES[address.uf] || address.uf
        };
      }

      async function getShippingRates(cep, province) {
        const params = new URLSearchParams();

        params.set("shipping_address[zip]", cep);
        params.set("shipping_address[country]", BRAZIL);

        if (province) {
          params.set("shipping_address[province]", province);
        }

        const response = await fetch(getShopifyRoot() + "cart/shipping_rates.json?" + params.toString(), {
          headers: {
            Accept: "application/json"
          }
        });

        const payload = await parseJson(response);

        if (!response.ok) {
          throw new Error(getResponseMessage(payload) || "Falha ao consultar as opcoes de frete.");
        }

        return Array.isArray(payload.shipping_rates) ? payload.shipping_rates : [];
      }

      function rememberShippingAddress(cep, province) {
        try {
          sessionStorage.setItem(
            SHIPPING_CONTEXT_STORAGE_KEY,
            JSON.stringify({
              zip: cep,
              country: BRAZIL,
              province: province || ""
            })
          );
        } catch (error) {
          // sessionStorage can be unavailable in some privacy modes.
        }
      }

      async function restoreShippingAddressContext(snapshotCart) {
        const previousAddress = getRememberedShippingAddress() || getDefaultShippingAddress();

        if (previousAddress) {
          await requestShippingRatesContext(previousAddress);
        }

        await restoreCartItems(snapshotCart);
      }

      async function restoreCartItems(snapshotCart) {
        if (!snapshotCart || !Array.isArray(snapshotCart.items) || !snapshotCart.items.length) {
          return;
        }

        const currentCart = await getCart().catch(function () {
          return null;
        });

        if (!currentCart || !Array.isArray(currentCart.items)) {
          return;
        }

        const currentLineQuantities = currentCart.items.reduce(function (lines, item) {
          lines[item.key] = (lines[item.key] || 0) + item.quantity;
          return lines;
        }, {});

        const itemsToRestore = snapshotCart.items
          .map(function (item) {
            const currentQuantity = currentLineQuantities[item.key] || 0;
            const missingQuantity = item.quantity - currentQuantity;

            if (missingQuantity <= 0) {
              return null;
            }

            return getRestorableCartItem(item, missingQuantity);
          })
          .filter(Boolean);

        if (!itemsToRestore.length) {
          return;
        }

        try {
          const restoreResponse = await fetch(getShopifyRoot() + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              items: itemsToRestore
            })
          });

          if (restoreResponse.ok) {
            const restoredCart = await getCart().catch(function () {
              return null;
            });

            syncCartSummary(restoredCart);
          }
        } catch (error) {
          console.error("Erro ao restaurar itens do carrinho apos consulta de frete.", error);
        }
      }

      function getRestorableCartItem(item, quantity) {
        const restorableItem = {
          id: item.variant_id,
          quantity: quantity
        };

        if (item.properties && Object.keys(item.properties).length) {
          restorableItem.properties = item.properties;
        }

        const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id || item.selling_plan;

        if (sellingPlanId) {
          restorableItem.selling_plan = sellingPlanId;
        }

        return restorableItem;
      }

      function syncCartSummary(cart) {
        if (!cart) {
          return;
        }

        if (typeof window.cartCount === "function") {
          window.cartCount(cart);
        }

        if (typeof window.initFreeshippingGoal === "function") {
          window.initFreeshippingGoal(cart);
        }
      }

      function getRememberedShippingAddress() {
        try {
          const rawAddress = sessionStorage.getItem(SHIPPING_CONTEXT_STORAGE_KEY);
          const parsedAddress = rawAddress ? JSON.parse(rawAddress) : null;

          if (parsedAddress && parsedAddress.zip && parsedAddress.country) {
            return parsedAddress;
          }
        } catch (error) {
          return null;
        }

        return null;
      }

      function getDefaultShippingAddress() {
        const zip = onlyDigits(calculator.dataset.resetShippingZip);
        const country = calculator.dataset.resetShippingCountry || BRAZIL;
        const province = calculator.dataset.resetShippingProvince || "";

        if (!zip || !country) {
          return null;
        }

        return {
          zip: zip,
          country: country,
          province: province
        };
      }

      function requestShippingRatesContext(address) {
        if (!address || !address.zip || !address.country) {
          return;
        }

        const params = new URLSearchParams();

        params.set("shipping_address[zip]", address.zip || "");
        params.set("shipping_address[country]", address.country || "");
        params.set("shipping_address[province]", address.province || "");

        return fetch(getShopifyRoot() + "cart/shipping_rates.json?" + params.toString(), {
          headers: {
            Accept: "application/json"
          }
        }).catch(function () {});
      }

      function renderRates(rates) {
        results.innerHTML = "";

        const list = document.createElement("div");
        list.className = "shipping-calculator__results overflow-hidden rounded";

        rates.forEach(function (rate) {
          const item = document.createElement("div");
          item.className = "shipping-calculator__rate px-4 py-3";

          const rawServiceName = rate.presentment_name || rate.name || "Entrega";
          const serviceName = escapeHtml(rawServiceName === "Local Delivery" ? "Delivery" : rawServiceName);
          const deadline = escapeHtml(getDeadlineLabel(rate));
          const price = formatPrice(rate.price);

          item.innerHTML = `
            <div class="wrapper-shipping-results">
              <p class="shipping-name">${serviceName}</p>
              <div>
                <p class="shipping-date">${deadline}</p>
                <p class="shipping-price">${price}</p>
              </div>
            </div>
          `;

          list.appendChild(item);
        });

        results.appendChild(list);
      }

      function getDeadlineLabel(rate) {
        const minDays = getNumber(
          rate.min_delivery_time || rate.minDeliveryTime || rate.min_delivery_days || rate.delivery_range?.min
        );
        const maxDays = getNumber(
          rate.max_delivery_time || rate.maxDeliveryTime || rate.max_delivery_days || rate.delivery_range?.max
        );
        const singleDays = getNumber(
          Array.isArray(rate.delivery_days)
            ? rate.delivery_days[0]
            : rate.delivery_days || rate.delivery_time || rate.estimated_days
        );

        if (minDays && maxDays) {
          return "" + minDays + " a " + maxDays + " dias uteis";
        }

        if (singleDays) {
          return "" + singleDays + (singleDays === 1 ? " dia util" : " dias uteis");
        }

        if (rate.description) {
          return "" + rate.description;
        }

        return "Prazo sob consulta";
      }

      function formatPrice(price) {
        const numericPrice = Number(String(price).replace(",", "."));

        if (!Number.isFinite(numericPrice)) {
          return "Valor indisponivel";
        }

        if (numericPrice === 0) {
          return "Gratis";
        }

        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL"
        }).format(numericPrice);
      }

      function setLoading(isLoading) {
        button.disabled = isLoading;
        button.textContent = isLoading ? "Calculando" : "Consultar";
      }

      function setFeedback(message, type) {
        const colors = {
          error: "#b91c1c",
          info: "#4b5563"
        };

        feedback.textContent = message;
        feedback.style.color = colors[type] || colors.info;
      }

      function clearOutput() {
        feedback.textContent = "";
        results.innerHTML = "";
      }

      function resetCalculator() {
        activeRequestId++;
        clearOutput();
        setLoading(false);
      }

      function maskCep(event) {
        let value = onlyDigits(event.target.value).slice(0, 8);

        if (value.length > 5) {
          value = value.replace(/^(\d{5})(\d{0,3})$/, "$1-$2");
        }

        event.target.value = value;
      }
    });
  }

  function getNumber(value) {
    if (value == null) {
      return null;
    }

    const match = String(value).match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
  }

  function onlyDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function parseServiceableZipRules(value) {
    return String(value || "")
      .split(/[\s,;]+/)
      .map(function (rule) {
        return rule.trim();
      })
      .filter(Boolean)
      .map(parseServiceableZipRule)
      .filter(Boolean);
  }

  function parseServiceableZipRule(rule) {
    const normalizedRule = String(rule || "").replace(/\s/g, "");

    if (!normalizedRule) {
      return null;
    }

    if (normalizedRule.indexOf("*") > -1) {
      const prefix = onlyDigits(normalizedRule.split("*")[0]);

      return prefix ? { type: "prefix", value: prefix } : null;
    }

    const exactZip = onlyDigits(normalizedRule);

    if (exactZip.length === 8) {
      return { type: "exact", value: exactZip };
    }

    const rangeMatch = normalizedRule.match(/^(\d[\d.-]*)-(\d[\d.-]*)$/);

    if (rangeMatch) {
      const start = onlyDigits(rangeMatch[1]);
      const end = onlyDigits(rangeMatch[2]);

      if (start && end) {
        return {
          type: "range",
          start: start.padEnd(8, "0").slice(0, 8),
          end: end.padEnd(8, "9").slice(0, 8)
        };
      }
    }

    return exactZip ? { type: "exact", value: exactZip } : null;
  }

  function isServiceableZip(cep, rules) {
    return rules.some(function (rule) {
      if (rule.type === "prefix") {
        return cep.indexOf(rule.value) === 0;
      }

      if (rule.type === "range") {
        return cep >= rule.start && cep <= rule.end;
      }

      return cep === rule.value;
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getShopifyRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  function parseJson(response) {
    return response.json().catch(function () {
      return {};
    });
  }

  function getResponseMessage(payload) {
    if (!payload || typeof payload !== "object") {
      return "";
    }

    if (payload.message || payload.description) {
      return [payload.message, payload.description].filter(Boolean).join(": ");
    }

    if (payload.errors && typeof payload.errors === "object") {
      return Object.keys(payload.errors)
        .map(function (key) {
          const value = payload.errors[key];
          return Array.isArray(value) ? value.join("; ") : value;
        })
        .filter(Boolean)
        .join("; ");
    }

    return "";
  }

  window.initAdegaShippingCalculators = initShippingCalculators;
  window.resetAdegaShippingCalculators = function (root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".js-shipping-calculator").forEach(function (calculator) {
      if (calculator.AdegaShippingCalculator && typeof calculator.AdegaShippingCalculator.reset === "function") {
        calculator.AdegaShippingCalculator.reset();
        return;
      }

      calculator.dispatchEvent(new CustomEvent("shipping-calculator:reset"));
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initShippingCalculators(document);
    });
  } else {
    initShippingCalculators(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initShippingCalculators(event.target || document);
  });
})();
